import React from "react";

const Footer = () => {
  return (
    <div style={{ backgroundColor: "#F8F8F6 " }}>
      <div className="container mt-5">
        <div className="row">
          <div className="col-sm-3 mt-5">
            <h4 className="text-uppercase font-weight-bold text-muted">
              Studentshelter
            </h4>
          </div>
          <div className="col-sm-2 mt-3">
            <p>About Us</p>
            <p>Blog</p>
          </div>
          <div className="col-sm-3 mt-3">
            <p>How It Works</p>
            <p>Help Center</p>
            <p>Contact Us</p>
          </div>
          <div className="col-sm-4 mt-3 mb-2">
            <p>Subscribe for our newsletter</p>
            <div className="footer">
              <input
                type="text"
                className=" subscribeemail"
                placeholder="Email Address"
              />
              <button type="submit" className="btn btn-secondary subscribebtn">
                Subscribe
              </button>
            </div>
            <br />
            <span style={{ fontSize: "27px" }}>
              <i className="fab fa-facebook text-muted"></i>
              <i className="fab fa-instagram text-muted ml-4"></i>
              <i className="fab fa-twitter ml-4 text-muted"></i>
            </span>
          </div>

          <p className="text-center text-muted">
            Privacy &nbsp;&nbsp;&nbsp; Terms&nbsp;&nbsp;&nbsp; &copy;{" "}
            {new Date().getFullYear()} Studentshelter
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
